module.exports = __webpack_public_path__ + "static/img/gonhong1.439c979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gonhong1.png
// module id = XEPs
// module chunks = 10